const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
const Menu = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domMenuBtn: $('.js-menu-btn'),
	$domMenuOuter: $('.js-nav-outer'),
	$domMenuInner: $('.js-nav-inner'),
	$domMenuIcon: $('.js-nav-icon'),
	$domMenuSub: $('.sub-menu').not('.btn--header > .sub-menu'),
	slMenuIcon: '.js-nav-icon',
	slMenuSub: '.sub-menu',
	classActive: 'is-active',
	classFixed: 'prevent-scroll',
	timeout: null,

	/** @description Initialize */
	init: function() {
		this.bindEvents();
		$('.site-nav__list > .menu-item').each(function(index) {
			$(this).css('--index', index + 1);
		});
	},

	/** @description Bind Events */
	bindEvents: function() {
		this.$domMenuBtn.on('click', this.toggleMenu.bind(this));
		this.$domMenuIcon.on('click', this.toggleSubMenu.bind(this));
		Global.escKey(this.closeMenu.bind(this));
		Global.clickOutsideContainer(Global.$domBody, this.$domMenuInner, this.$domMenuBtn, this.closeMenu.bind(this));
	},

	toggleMenu: function() {
		if (!this.$domMenuBtn.hasClass(this.classActive)) {
			this.$domMenuBtn.addClass(this.classActive).attr('aria-expanded', 'true');
			this.$domMenuOuter.addClass(this.classActive);
			Global.$domBody.addClass(this.classFixed);
		} else {
			this.closeMenu();
			Global.$domBody.removeClass(this.classFixed);
		}
	},

	toggleSubMenu(e) {
		const icon = $(e.target).closest(this.slMenuIcon);
		const ul = icon.siblings(this.slMenuSub);

		if (!icon.hasClass(this.classActive)) {
			icon.addClass(this.classActive);
			icon.parent().addClass(this.classActive);
			ul.slideDown();
		} else {
			icon.removeClass(this.classActive);
			icon.parent().removeClass(this.classActive);
			icon.parent().find(this.slMenuIcon).removeClass(this.classActive);
			ul.slideUp();
			ul.find(this.slMenuSub).slideUp();
		}
	},

	closeMenu: function() {
		this.$domMenuBtn.removeClass(this.classActive).attr('aria-expanded', 'false');
		this.$domMenuOuter.removeClass(this.classActive);
		Global.$domBody.removeClass(this.classFixed);

		// timeout should match the selectors CSS transition duration property
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.$domMenuIcon.removeClass(this.classActive);
			$('.menu-item').removeClass(this.classActive);
			this.$domMenuSub.slideUp();
		}, 300);
	}
};

export default Menu;
